import React, { useCallback, useState } from "react";

import { useRouter } from "next/router";
import { toast } from "react-toastify";

import { APP_ROUTES } from "@/constants/routes";
import { handleAxiosError } from "@/helpers/common";

function NoDataContainer() {
    const router = useRouter();
    const [isLoading, setIsLoading] = useState(false);
    const resetFilter = useCallback(async () => {
        setIsLoading(true);
        try {
            // const res = await saveFilterSearchService(getInitialMainFilter());
            // handleAxiosSuccess("Results updated", toast);
            // router.push(`${APP_ROUTES.mainExplore}/${res.data.data.searchId}`);
            router.push(`${APP_ROUTES.mainExplore}`);
        } catch (error) {
            handleAxiosError(error, toast);
        }
        setIsLoading(false);
    }, [router]);

    return (
        <div className="no-data-container">
            {
                isLoading
                && <div className="commonLoader">
                    <div className="commonProgress">
                        <img src="/images/loading-gif.gif" alt="loader_image" />
                    </div>
                </div>
            }
            <img src="/images/search.png" alt="search" />
            <p>
                That is a very specific search! <br />Currently no UK companies match this exact criteria.
            </p>
            <button
                className="btn-pink"
                onClick={resetFilter}>Reset filters</button>
        </div>
    );
}

export default NoDataContainer;
